define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../store", "../services"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, store_1, services_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrDoc = void 0;
    class SrCrDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "CrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUploadError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SrCrDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.SrCr = parent;
            this.CrId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.SrCr = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.CrId = (0, EntityUtil_1.toInt)(entity.CrId);
            a.DocType = (0, EntityUtil_1.toInt)(entity.DocType);
            a.DocName = b.DocName;
            a.DocDesc = b.DocDesc;
            a.DocStatus = b.DocStatus;
            a.IsUpload = (0, EntityUtil_1.toInt)(entity.IsUpload);
            a.CreateUser = b.CreateUser;
            a.CreateDate = b.CreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SrCrDoc.AliasName);
            this.reset();
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "CrId", "Permit Id");
                this.validateReqNumber(validationState, "DocType", "Document Type");
                this.validateReqString(validationState, "DocStatus", "Document Status");
                this.validateReqNumber(validationState, "IsUpload", "Is Uploaded?");
                this.validateReqString(validationState, "CreateUser", "Create User");
                this.validateReqDate(validationState, "CreateDate", "Create Date");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                CrId: this.CrId,
                DocType: this.DocType,
                DocName: this.DocName,
                DocDesc: this.DocDesc,
                DocStatus: this.DocStatus,
                IsUpload: this.IsUpload,
                CreateUser: this.CreateUser,
                CreateDate: this.CreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static openDocument(document) {
            services_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.getSrCrDocument(document.Id);
        }
        static uploadDocument(cr, documentType, fileName, base64File) {
            return new Promise((resolve, reject) => {
                store_1.StoreManager.Instance.notificationStore.push("Uploading Document");
                if (cr.hasChanges()) {
                    store_1.StoreManager.Instance.modalStore.createInfoModal("You have unsaved changes. Please save your work before uploading a document", null);
                }
                else {
                    services_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.uploadSrCrDocument(cr.Id, documentType, fileName, base64File).then(d => {
                        let x = new SrCrDoc(d, cr);
                        cr.SrCrDoc.push(x);
                        resolve(x);
                    });
                }
            });
        }
    }
    exports.SrCrDoc = SrCrDoc;
    Object.defineProperty(SrCrDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SrCrDoc"
    });
    Object.defineProperty(SrCrDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SR CR Documents"
    });
    Object.defineProperty(SrCrDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "CrId", "DocType", "DocName", "DocDesc", "DocStatus", "IsUpload", "CreateUser", "CreateDate", "AuditEditUser", "AuditEditDate"]
    });
    Object.defineProperty(SrCrDoc, "CrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "DocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "DocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "DocNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCrDoc, "DocNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrDoc, "DocDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCrDoc, "DocDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrDoc, "DocStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(SrCrDoc, "DocStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "DocStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "IsUploadReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "CreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCrDoc, "CreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "CreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrDoc, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCrDoc, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrDoc, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "DocStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "IsUpload", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "IsUploadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "CreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrDoc.prototype, "SrCr", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrDoc.prototype, "merge", null);
});
